'use strict';

require('./fonts.local.css');

require('./globals.local.css');